import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Pagination from "../../../entities/Pagination";
import TransactionStatus from "../../../entities/TransactionStatus";
import { ArticleTransactionService } from "../../../service/ArticleTransactionService";
import Article from "../../../entities/Article";
import ArticleTransactionResponse from "../../../model/articleTransaction/ArticleTransactionResponse";

class ArticleTransactionsStore {

    public entityId?: string;
    public articleId?: string;
    public loading: boolean;
    public articleLoading: boolean;
    public commonStore: CommonStore;

    public pagination: Pagination;
    public articleTransactionTypeFilter?: string;

    public articlePagination: Pagination;
    public articleTransactions: ArticleTransactionResponse[];
    public articleFrom?: number;
    public articleTo?: number;
    public articleStatus?: TransactionStatus;
    public articleFilter?: Article;

    constructor(commonStore: CommonStore, articleId?: string, entityId?: string) {
        this.entityId = entityId;
        this.articleId = articleId;
        this.loading = false;
        this.articleLoading = false;
        this.commonStore = commonStore;
        this.pagination = new Pagination(1, 10, 0, 0);
        this.articlePagination = new Pagination(1, 10, 0, 0);
        this.articleTransactions = [];
        makeAutoObservable(this);
    }

    @action
    public async searchArticleTransactions(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.articleLoading = true;
        const response = await ArticleTransactionService.get(
            this.entityId,
            page,
            pageSize,
            this.articleFrom,
            this.articleTo,
            this.articleStatus,
            this.articleId ?? this.articleFilter?.id,
            this.articleTransactionTypeFilter
        );
        if (response.success) {
            runInAction(() => {
                this.articleTransactions = response.data?.data || [];
                this.articlePagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.articleLoading = false;
    }

    get isEmpty(): boolean {
        return this.articleTransactions.length === 0;
    }

    @action
    public async cleanArticleFilter() {
        this.articleFrom = undefined;
        this.articleTo = undefined;
        this.articleFilter = undefined;
        this.articleTransactionTypeFilter = undefined;
        await this.searchArticleTransactions();
    }

    get isArticleEmpty(): boolean {
        return this.articleTransactions.length === 0;
    }

    @action
    public async goToArticlePage(page: number = this.articlePagination.currentPage, pageSize: number = this.articlePagination.pageSize): Promise<void> {
        await this.searchArticleTransactions(page, pageSize);
    }

}

export default ArticleTransactionsStore;